import { OkrSession } from "server/models"
import { TableGroupedIds } from "client/components"

export interface OkrSessionProps {
    sessionId: number
}

export interface OkrSessionList { [sessionId: number]: OkrSession }
export type OkrSessionValidation = { [key in keyof OkrSession]?: string}

export interface OkrSessionFilters {
    showInProgress: boolean
    showArchived: boolean
    search?: string
}

export interface OkrSessionState {
    sessionList: OkrSessionList
    sessionIds: readonly TableGroupedIds[]
    sessionView: OkrSession
    sessionEdit: OkrSession

    // to select parent
    availableSessions: readonly OkrSession[]

    // popup menu
    active: OkrSession
    menuShow: boolean
    menuTarget: any

    showConfirmDelete: boolean
    showArchived: boolean

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const OKR_SESSION_LIST = "OKR_SESSION_LIST"
export const OKR_SESSION_IDS = "OKR_SESSION_IDS"
export const OKR_SESSION_VIEW = "OKR_SESSION_VIEW"
export const OKR_SESSION_EDIT = "OKR_SESSION_EDIT"

// to select parent
export const OKR_SESSION_AVAILABLE_SESSIONS = "OKR_SESSION_AVAILABLE_SESSIONS"

// popup menu
export const OKR_SESSION_ACTIVE = "OKR_SESSION_ACTIVE"
export const OKR_SESSION_POPUP_MENU_SHOW = "OKR_SESSION_POPUP_MENU_SHOW"
export const OKR_SESSION_POPUP_MENU_TARGET = "OKR_SESSION_POPUP_MENU_TARGET"
export const OKR_SESSION_SHOW_CONFIRM_DELETE = "OKR_SESSION_SHOW_CONFIRM_DELETE"

export const OKR_SESSION_SHOW_ARCHIVED = "OKR_SESSION_SHOW_ARCHIVED"

export const OKR_SESSION_RELOAD_LIST = "OKR_SESSION_RELOAD_LIST"
export const OKR_SESSION_RELOAD_VIEW = "OKR_SESSION_RELOAD_VIEW"
export const OKR_SESSION_RELOAD_EDIT = "OKR_SESSION_RELOAD_EDIT"
